var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 48.5C0 21.7142 21.7142 0 48.5 0C75.2858 0 97 21.7142 97 48.5C97 75.2858 75.2858 97 48.5 97C21.7142 97 0 75.2858 0 48.5Z",
    fill: "#6429CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1526 24.4477C33.6717 24.1643 34.3041 24.187 34.8015 24.5068L70.0089 47.1401C70.4717 47.4376 70.7514 47.9499 70.7514 48.5C70.7514 49.0501 70.4717 49.5624 70.0089 49.8599L34.8015 72.4932C34.3041 72.813 33.6717 72.8357 33.1526 72.5523C32.6335 72.2689 32.3106 71.7247 32.3106 71.1333V25.8667C32.3106 25.2753 32.6335 24.7311 33.1526 24.4477ZM35.544 28.8279V68.1721L66.1451 48.5L35.544 28.8279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFilled);
export default __webpack_public_path__ + "static/media/play-filled.8a23d4caa4f4ddb1546e8c857a3a98bb.svg";
export { ForwardRef as ReactComponent };